/* eslint-disable  @typescript-eslint/no-explicit-any */
import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Feed {
    username: string
    token: string
}

const leaderboardModule: Module<any, any> = {
    state: {
        showLeaderboard: false,
        filters: {},
    },

    actions: {
        async ShowLeaderboard({ commit }, { show }) {
            commit('setShowLeaderboard', show)
        },
    },

    mutations: {
        setShowLeaderboard(state: any, show) {
            state.showLeaderboard = show
        },
    },
}

export default leaderboardModule
